window.addEventListener("DOMContentLoaded", (event) => {
  // animated text in blocks
  (function () {
    function start_marquee() {
      function go() {
        i = i < width ? i + step : 1;
        m.style.marginLeft = -i + "px";
      }
      var i = 0,
        step = 3,
        space = "&nbsp;&nbsp;&nbsp;";
      var m = document.getElementById("marquee");
      var t = m.innerHTML;
      m.innerHTML = t + space;
      m.style.position = "absolute";
      var width = m.clientWidth + 1;
      m.style.position = "";
      m.innerHTML =
        t +
        space +
        t +
        space +
        t +
        space +
        t +
        space +
        t +
        space +
        t +
        space +
        t +
        space;

      var x = setInterval(go, 30);
    }
    if (document.getElementById("marquee")) {
      if (window.addEventListener) {
        window.addEventListener("load", start_marquee, false);
      } else if (window.attachEvent) {
        window.attachEvent("onload", start_marquee);
      }
    }
  })();

  // when click outside of help/contact hide container
  document.body.addEventListener("click", function (e) {
    if (
      document.getElementById("help-content").style.display == "block" &&
      e.target.id != "help-announcement"
    ) {
      if (!document.getElementById("help-content").contains(e.target)) {
        viewEvent();
      }
    }

    // detect when click and hide big logo and vice versa
    changeLogo();
  });

  // when click button show container of ways of contact
  document.getElementById("help-announcement").addEventListener(
    "click",
    function (event) {
      if (document.getElementById("help-content").style.display == "block") {
        document.getElementById("help-content").style.display = "none";
      } else {
        document.getElementById("help-content").style.display = "block";
        document.addEventListener("scroll", viewEvent);
      }
    },
    false
  );

  // function to display none the container
  function viewEvent() {
    document.getElementById("help-content").style.display = "none";
  }

  window.addEventListener("scroll", function (e) {
    // get height header, so when customer scrolls filters fixed on top
    if (document.querySelector("#collection-top-bar__filters")) {
      let header = document.querySelector("#header");
      let topbarFilters = document.querySelector(
        "#collection-top-bar__filters"
      );
      let heightHeader = header.offsetHeight;
      topbarFilters.style.top = heightHeader + "px";
    }

    // detect when scroll and hide big logo and vice versa
    changeLogo();
  });

  // hide big logo and vice versa
  function changeLogo() {
    if (window.innerWidth >= 960) {
      let scrollY = window.scrollY;
      if (scrollY > 20) {
        document.getElementById("logoNormal").style.display = "flex";
        document.getElementById("logoBig").style.display = "none";
      } else {
        document.getElementById("logoNormal").style.display = "none";
        document.getElementById("logoBig").style.display = "block";
      }
    }
  }

  //backdrop modal
  MutationObserver =
    window.MutationObserver ||
    window.WebKitMutationObserver ||
    window.MozMutationObserver;

  // define a new observer
  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; ++i) {
      for (var j = 0; j < mutations[i].addedNodes.length; ++j) {
        if (mutations[i].addedNodes[j].classList === undefined) {
          continue;
        }

        if (mutations[i].addedNodes[j].classList.contains("cc-window")) {
          var observer = new MutationObserver(styleChangedCallback);
          observer.observe(mutations[i].addedNodes[j], {
            attributes: true,
            childList: true,
            characterData: true,
          });
        }
      }
    }
  });

  function styleChangedCallback(mutations) {
    if (!mutations[0].target.classList.contains("cc-invisible")) {
      document.getElementById("backdrop-modal-policies").style.display =
        "block";
      var observer = new MutationObserver(styleChangedCallback);
    }
    if (mutations[0].target.style.display == "none") {
      document.getElementById("backdrop-modal-policies").style.display = "none";
      obs.disconnect();
    }
  }

  // Configuration of the observer:
  var config = {
    attributes: true,
    childList: true,
    characterData: true,
  };

  // Pass in the target node, as well as the observer options
  obs.observe(document.body, config);
});
